import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brouillon-devis-negoce',
  templateUrl: './brouillon-devis-negoce.component.html',
  styleUrls: ['./brouillon-devis-negoce.component.scss']
})
export class BrouillonDevisNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
